import { gql } from '@apollo/client';
import { ClientListFragment } from '../fragments/ClientListFragment';
/**
 * @const ClientListQuery
 * @since 1.0.0
 */
export const ClientListQuery = gql `
  query ClientListQuery($input: ClientsInput) {
    clients(input: $input) {
      items {
        ...ClientListFragment
      }
      count
    }
  }

  ${ClientListFragment}
`;
